import { Base } from '@studiometa/js-toolkit';
import axios from 'axios';

/**
 * Homepage class.
 */
export default class FormDl extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'FormDl',
    refs: ['form'],
    options: {},
  };

  /**
   *
   */
  mounted() {
    if (!this.$refs.form) {
      const form = this.$el.querySelector('[data-ref="form"]');

      if (form) {
        form.addEventListener('submit', (e) => {
          this.onFormSubmit(e);
        });
        this.$refs.form = form;
      }
    }
  }

  /**
   * Listener submit
   * @param {*} e
   */
  onFormSubmit(e) {
    e.preventDefault();

    const form = e.target;

    const formD = new FormData(form);

    const method = form.getAttribute('method');
    let url = form.getAttribute('action');

    if (method === 'get') {
      url += `?${new URLSearchParams(formD).toString()}`;
    }

    // Delete msg if exist
    const msg = form.querySelector('.msg');
    if (msg) msg.remove();

    form.classList.add('pointer-events-none');

    axios({
      method,
      url,
      data: formD,
    }).then((response) => {
      form.classList.remove('pointer-events-none');

      if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
        const content = document.createElement('div');
        content.innerHTML = response.data;

        const error = content.querySelector('.msg');
        if (error) {
          form.prepend(error);
        }
      } else {
        const type = response.headers['content-type'];
        const ext = type.slice(Math.max(0, type.lastIndexOf('/') + 1));
        const title = formD.get('title') ? formD.get('title') : 'mon-fichier';
        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', `${title}.${ext}`);
        a.click();

        this.$emit('success');
      }
    });
  }
}
